import { render, staticRenderFns } from "./KlaimForm.vue?vue&type=template&id=99b53360&"
import script from "./KlaimForm.vue?vue&type=script&lang=js&"
export * from "./KlaimForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports